import React, { useState } from "react";
import { DOCUMENT_CONTENT_TYPE_PDF, DOCUMENT_TYPE_FORMS_AGREEMENTS, individualFileSizeAllowedInMB } from "../../../../../app/constants";
import { ERROR_STRING, VALIDATION_ERROR } from "../../../../../app/errors";
import { acceptedFileFormats, fileTypeEnum, extractBase64, NOT_ALLOWED_CHARS, fileNameWithLengthLimit, convertFileDataForUrl  } from "../../../../../app/documentUploadUtils";
import { Button, ErrorWithString, NavigationLinkButton } from "../../../../../components/RegularComponents";
import { DocumentViewerFileNameLink, DownloadFileNameLink } from "../../../../../components/DocumentViewer/DocumentFileComponent";
import { fetchDocumentData } from "../../../../../redux/slice/supportingDocumentsSlice";
import DocumentViewer from "../../../../../components/DocumentViewer/DocumentViewer";
import { useDispatch } from "react-redux";
import { documentTypeString } from "../../../../../app/utils";

export const CommonAttachmentFileUpload = (props) => {
    const { documentTypes } = props
    console.log(documentTypes)
    const [showValidationError/*, setShowValidationError*/] = useState(false)
    const [formsValidationError/*, setFormsValidationError*/] = useState(VALIDATION_ERROR.NO_ERROR)
    const [formsFile, setFormsFile] = useState(null)

    const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedDocumentType, setSelectedDocumentType] = useState(documentTypes?.length > 0 ? documentTypes[0] : null);

    const dispatch = useDispatch();
    
    const isFormsValid = () => {
        if (showValidationError) {
            return (formsValidationError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const fileComponent = (id, file, index) => {
        return (
          <>
            <div className="supportingDocumentsFileContentWrapper">
              <span className="fileName">
                {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? (
                  <DocumentViewerFileNameLink
                    id={"supporting-document-view-file-" + file.filename}
                    key={"supporting-document-view-file-" + file.filename}
                    file={file}
                    onClick={() => {
                      if (file.data) {
                        let fileDataUrl = convertFileDataForUrl(
                          file.data,
                          file.documentContentType
                        );
                        setDocumentViewerDocument(fileDataUrl);
                        setOpenDocumentViewer(true);
                        setSelectedFile(file);
                      } else {
                        // download data and then view it.
                        if (file.guid) {
                          dispatch(fetchDocumentData(file.guid))
                            .then((downloadFile) => {
                              if (downloadFile) {
                                let fileDataUrl = convertFileDataForUrl(
                                  downloadFile.data,
                                  downloadFile.documentContentType
                                );
                                setDocumentViewerDocument(fileDataUrl);
                                setOpenDocumentViewer(true);
                                setSelectedFile(downloadFile);
                              }
                            })
                            .catch((error) => {
                              console.error(error);
                            });
                        }
                      }
                    }}
                  />
                ) : (
                  <DownloadFileNameLink
                    id={"supporting-document-download-file-" + file.filename}
                    componentKey={
                      "supporting-document-download-file-" + file.filename
                    }
                    file={file}
                  />
                )}
              </span>
    
              <NavigationLinkButton
                id={id + "-remove-link"}
                text={"- Remove this file"}
                onClick={() => {
                  setFormsFile(null);
                }}
              />
            </div>
          </>
        );
      };

    const fileSizeReplacement = (string, fileSize) => {
        const replaceRegExp = /<file_size>/g
        const errorString = string.replace(replaceRegExp, (fileSize + "MB"))
        return errorString
    }

    const validateFileName = (filename) => {
        return !NOT_ALLOWED_CHARS.some(c => {

            if (filename.indexOf(c) !== -1) {
                return true
            }

            return false
        })
    }

    // const [docs, setDocs] = useState({formsAgreements: [], noticesLetters: [] });
    
    // useEffect(() => {
    //     const formsAgreements = []
    //     const noticesLetters = []
    //     const suretyBondDocs = []
    //     licenceApplication.documents?.forEach((document) => {
    //         if(document.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS) {
    //             formsAgreements.push(document)
    //         } else if(document.documentType === DOCUMENT_TYPE_NOTICES_LETTERS) {
    //             noticesLetters.push(document)
    //         } else if(document.documentType === DOCUMENT_TYPE_SURETY_BONDS) {
    //             suretyBondDocs.push(document);
    //         }
    //     })
    //     setDocs({formsAgreements, noticesLetters, suretyBondDocs})
    // }, [licenceApplication])

    const onFormsFileInputChange = (e) => {
        if (e.target.files.length > 0) {
            let file = e.target.files[0]

            // individual file size can not be more than 15 MB
            if (file.size > (individualFileSizeAllowedInMB * (2 ** 20))) {
                alert(fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE, individualFileSizeAllowedInMB))
                return
            } else if (!validateFileName(file.name)) {
                alert("File name is not valid. Please select another file.")
                return
            }

            let reader = new FileReader()
            reader.onload = (readerData) => {
                setFormsFile({
                    filename: fileNameWithLengthLimit(file.name),
                    documentType : selectedDocumentType,
                    documentContentType: fileTypeEnum(file.type),
                    data: extractBase64(readerData.target.result),
                    changeType: "SAVE",
                    fileSize: file.size
                })
            }
            reader.readAsDataURL(file)
        }
    }

    const handleUpload = () => {
        // save and push to next
        if(props.handleFileUpload) {
            props.handleFileUpload(formsFile)
            setFormsFile(null)
        }

        // const {formsAgreements, noticesLetters, suretyBondDocs} = docs
        
        // // dispatch(setAgencySupportingDocuments({
        // //     formsAgreements: documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS ? [...formsAgreements, formsFile] : formsAgreements,
        // //     noticesLetters: documentType === DOCUMENT_TYPE_NOTICES_LETTERS ? [...noticesLetters, formsFile] : noticesLetters,
        // //     suretyBondDocs
        // // }))
        // console.log(docs)
        // const newSupportingDocs = [...formsAgreements, ...noticesLetters, ...suretyBondDocs, formsFile]
        // dispatch(setAgencySupportingDocuments(newSupportingDocs))

        // dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
        //     .then((data) => {
        //         // window.location.reload();
        //         // let nextUrl = window.location.href// supportingDocuments.navigation.next
        //         // if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
        //         //     && supportingDocuments.navigation.nextRenewal) {
        //         //     nextUrl = supportingDocuments.navigation.nextRenewal
        //         // }
        //         // dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
        //     })
        //     .catch(err => {
        //         // setApplicationSaveError(true)
        //     })
    }

    // const handlDocumentTypeChange = (event) => {
    //     const value = event.target.value
    //     setDocumentType(value);
    // }

    return (
        <>
            <div className="row">
                <div className="collector-licence-col col-md-3" style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
                    <span>Add attachment</span>
                </div>

                <div className="collector-licence-col col-md-9" style={{ display: "flex", flexGrow: 1, justifyContent: "space-around" }}>
                    <div style={{ flexGrow: 1 }}>
                        <fieldset className="ns-fieldset">
                            <div className={"ns-fieldset" + (!isFormsValid() ? " ns-fieldset-message-error" : "")}>
                                {formsFile?.filename ? 
                                <>
                                    {(fileComponent("uploaded-file", formsFile))}
                                    <div className="topMarginNormal">
                                        <Button 
                                            className="btn btn-primary" 
                                            onClick={handleUpload}
                                            text="Upload" 
                                        />
                                    </div>
                                </> :
                                    (<>
                                        <label
                                            id="supporting-document-notices-file-label"
                                            className="ns-label"
                                            htmlFor="supporting-document-notices-file-input">
                                            Upload a file
                                        </label>
                                        <div className="ns-file-input" style={{ display: "flex", flexDirection: "column" }}>
                                            <input
                                                // style={{ width: "15em", display: "inline" }}
                                                type="file"
                                                className="ns-input"
                                                id="supporting-document-notices-file-input"
                                                name="supporting-document-notices-file-input"
                                                accept={acceptedFileFormats(DOCUMENT_TYPE_FORMS_AGREEMENTS).join(',')}
                                                multiple={false}
                                                value=""
                                                onInput={onFormsFileInputChange} />
                                        </div>
                                    </>)}

                                {!isFormsValid() && <div className="ns-error-message form-validation-error topMarginNormal">
                                    {ErrorWithString(ERROR_STRING.SUPPORTING_DOC_MISSING_NOTICE)}
                                </div>}
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
            {(documentTypes && Array.isArray(documentTypes) && documentTypes.length > 1) && 
            <>
                <div className="row">
                    <div 
                        className="collector-licence-col col-md-8" 
                        style={
                            {
                                display: "flex", 
                                flexDirection: "column", 
                                alignItems: "center"
                            }
                        }
                    >
                        <fieldset className="ns-fieldset">
                            <div className={"ns-radios ns-radios--small"}>
                                {documentTypes.map(docType => {
                                    return (
                                    <div className="ns-radios__item">
                                        <input
                                            className="ns-radios__input"
                                            type={"radio"}
                                            value={docType}
                                            checked={selectedDocumentType === docType}
                                            onChange={() => setSelectedDocumentType(docType)}
                                            id={"bltinformation-document-type-input-" + {docType}}
                                            name={"bltinformation-document-type-input-" + {docType}}
                                        />
                                        <label
                                            id={"bltinformation-document-type-label-" + {docType}}
                                            className="ns-radios__label"
                                            htmlFor={"bltinformation-document-type-input-" + {docType}}>
                                            <span className="bltReviewDecisionInfo">
                                                {documentTypeString(docType)}
                                            </span>
                                        </label>
                                    </div>     
                                    )
                                })}
                            </div>
                        </fieldset>
                    </div>
                </div>
            </>
            }
            {/* <div className="row">
                <div className="collector-licence-col col-md-8">
                    <fieldset className="ns-fieldset">
                        <div className={"ns-radios ns-radios--small"}>
                            <div className="ns-radios__item">
                                <input
                                    className="ns-radios__input"
                                    type={"radio"}
                                    value={DOCUMENT_TYPE_FORMS_AGREEMENTS}
                                    checked={documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS}
                                    onChange={handlDocumentTypeChange}
                                    id={"bltinformation-document-type-input"}
                                    name={"bltinformation-document-type-input"}
                                />
                                <label
                                    id={"bltinformation-document-type-label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltinformation-document-type-input"}>
                                    <span className="bltReviewDecisionInfo">Forms Agreements</span>
                                </label>
                            </div>

                            <div className="ns-radios__item">
                                <input
                                    className="ns-radios__input"
                                    type={"radio"}
                                    value={DOCUMENT_TYPE_NOTICES_LETTERS}
                                    checked={documentType === DOCUMENT_TYPE_NOTICES_LETTERS}
                                    onChange={handlDocumentTypeChange}
                                    id={"bltinformation-document-type-input"}
                                    name={"bltinformation-document-type-input"}
                                />
                                <label
                                    id={"bltreview-decision-form-approve-label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltinformation-document-type-input"}>
                                    <span className="bltReviewDecisionInfo">Notices Letters</span>
                                </label>
                            </div>



                        </div>
                    </fieldset>
                </div>
            </div> */}

            {/* <LineSeperator /> */}

            <DocumentViewer
                fileData={documentViewerDocument}
                isOpen={openDocumentViewer}
                fileName={selectedFile?.filename}
                handleClose={() => setOpenDocumentViewer(false)}
            />
        </>
    )
}